import { clsx } from 'clsx';
import React from 'react';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'success' | 'warning' | 'error' | 'info';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const Badge: React.FC<BadgeProps> = ({
  children,
  variant = 'primary',
  size = 'md',
  className,
}) => {
  const baseClasses = 'inline-flex items-center font-medium rounded-full';

  const variantClasses = {
    primary:
      'bg-primary-100 dark:bg-primary-900/20 text-primary-800 dark:text-primary-300',
    secondary:
      'bg-secondary-100 dark:bg-secondary-900/20 text-secondary-800 dark:text-secondary-300',
    success:
      'bg-success-100 dark:bg-success-900/20 text-success-800 dark:text-success-300',
    warning:
      'bg-warning-100 dark:bg-warning-900/20 text-warning-800 dark:text-warning-300',
    error:
      'bg-error-100 dark:bg-error-900/20 text-error-800 dark:text-error-300',
    info: 'bg-blue-100 dark:bg-blue-900/20 text-blue-800 dark:text-blue-300',
  };

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-0.5 text-xs',
    lg: 'px-3 py-1 text-sm',
  };

  return (
    <span
      className={clsx(
        baseClasses,
        variantClasses[variant],
        sizeClasses[size],
        className
      )}
    >
      {children}
    </span>
  );
};

export default Badge;
